'use strict';

// Vue
import Vue from 'vue';

// API
import {
  requestHomepagePhrases,
} from 'api/org';

// State
const state = {
};

// Getters
const getters = {
  homepagePhrases: state => state.homepagePhrases,
};

// Mutations
const mutations = {
  STORE_HOMEPAGE_PHRASES(state, payload) {
    Vue.set(state, 'homepagePhrases', payload);
  },
};

// Actions
const actions = {
  async getHomepagePhrases({ commit }) {
    try {
      const response = await requestHomepagePhrases();

      // ? WHY: Makes sure the default message doesn't get overoverwritten immediately
      setTimeout(() => {
        commit('STORE_HOMEPAGE_PHRASES', response.data);
      }, 5000);
     
      return response;
    } catch (error) {
      console.error('error requesting home page phrases', error);
      return error;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./client/store/home.js